/**
 * Utility functions for handling table row selection
 */

/**
 * Toggles a single item selection (string-based, for domains)
 */
export const toggleStringSelection = (
  currentSelected: string[],
  id: number | string
): string[] => {
  const stringId = typeof id === 'number' ? String(id) : id;
  const selectedIndex = currentSelected.indexOf(stringId);

  if (selectedIndex === -1) {
    // Add to selection
    return [...currentSelected, stringId];
  } else {
    // Remove from selection
    return currentSelected.filter((selectedId) => selectedId !== stringId);
  }
};

/**
 * Handles multiple item selection/deselection (string-based, for domains)
 */
export const toggleMultipleStringSelection = (
  currentSelected: string[],
  ids: (number | string)[],
  select: boolean
): string[] => {
  const stringIds = ids.map((id) => (typeof id === 'number' ? String(id) : id));

  if (select) {
    // Add all IDs that are not already selected
    const newIds = stringIds.filter((id) => !currentSelected.includes(id));
    return [...currentSelected, ...newIds];
  } else {
    // Remove all IDs that are currently selected
    return currentSelected.filter((id) => !stringIds.includes(id));
  }
};

/**
 * Handles select all/deselect all (string-based, for domains)
 */
export const toggleStringSelectAll = (
  allIds: (number | string)[],
  currentSelected: string[],
  checked: boolean
): string[] => {
  if (checked) {
    // Convert all IDs to strings and return them
    const stringIds = allIds.map((id) =>
      typeof id === 'number' ? String(id) : id
    );
    return stringIds;
  } else {
    // Return empty array to deselect all
    return [];
  }
};
